export default __webpack_public_path__ + "static/media/me.af32898c.jpg";